import { FC, memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Flex, Textarea } from '@chakra-ui/react';

export type ReplyFormProps = {
  isSending: boolean;
  onSend: (content: string) => Promise<void>;
};

export const ReplyForm: FC<ReplyFormProps> = memo(function ReplyForm({ isSending, onSend }) {
  const { t } = useTranslation();
  const [content, setContent] = useState('');

  const handleSend = async () => {
    const trimmed = content.trim();
    if (!trimmed) return;

    await onSend(trimmed);
    setContent('');
  };

  return (
    <Flex gap={2} align="flex-end">
      <Textarea
        value={content}
        onChange={(e) => setContent(e.target.value)}
        placeholder={t('messages.reply.placeholder')}
        rows={3}
        resize="vertical"
      />
      <Button onClick={handleSend} isLoading={isSending} isDisabled={!content.trim()} colorScheme="primary">
        {t('messages.reply.send')}
      </Button>
    </Flex>
  );
});
